export enum LeftPanelType {
  None = 0,
  Component = 1,
  DisplayItemTree = 2,
  Screens = 3,
  Code = 4,
  Datasources = 5,
  ComponentTree = 6,
  CodeTree = 7,
  ImageLibrary = 8,
  Language = 9,
  DataDiagramScheme = 10,
  WorkFlowList = 11,
  WorkFlowFieldList = 12,
  QueryBuilder = 13,
  ConfigManager = 14,
  NotificationTemplate = 15,
  ScheduledJobs = 16,
  ApiManagement = 17,
  Zendesk = 18,
  Reports = 19,
  ActionTree = 20,
  ButtonsPanel = 21,
  Audit = 22,
  AIChat = 23,
  Branching = 24,
  DocumentParameters = 25,
  Comments = 26
}

export enum RightPanelType {
  None = 0,
  Properties = 1,
  Styling = 2,
  Documents = 3,
  Comments = 4,
  History = 5,
  ExploreDocumentation = 5,
  Chatbot = 6,
  HappyPath = 7,
  WorkflowVersion = 8,
  AdvancedProperties = 9,
  AIChat = 10
}
